import { render, staticRenderFns } from "./FormPerfil.vue?vue&type=template&id=67c80814&"
import script from "./FormPerfil.vue?vue&type=script&lang=js&"
export * from "./FormPerfil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports